/**
 * Standalone Income Tax page — for employees in sidebar.
 * Wraps the shared IncomeTaxTab inside AppShell so the same component
 * powers both: (a) tab inside Payroll for HR (role-gated route)
 *              (b) standalone page for employees (this route).
 */
import AppShell from "../components/AppShell";
import IncomeTaxTab from "./IncomeTaxTab";

export default function IncomeTaxPage() {
  return (
    <AppShell title="Income Tax — FY 2025-26">
      <IncomeTaxTab />
    </AppShell>
  );
}
